import { render, staticRenderFns } from "./SmtpEditDetails.vue?vue&type=template&id=021dcb31&scoped=true&"
import script from "./SmtpEditDetails.vue?vue&type=script&lang=js&"
export * from "./SmtpEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021dcb31",
  null
  
)

export default component.exports